/* FIXME: This file will need to implement translations once the useDashboardReskinExperiment is implemented outside the US */
import type { JSX } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
// eslint-disable-next-line @change/sibling-module-imports
import { SHARE_BUTTON_CONFIG } from 'src/app/pages/starterDashboardV2/shared/hooks/useTriggerSharePetitionModal/useDashboardShareActions/constants';
// eslint-disable-next-line @change/sibling-module-imports
import { useTrackShareActionsView } from 'src/app/pages/starterDashboardV2/shared/hooks/useTriggerSharePetitionModal/useSharePetitionModal/hooks/useTrackShareActionsView';

import { SharePetitionButton } from './components/SharePetitionButton/index_new';
import { useShareSocial } from './hooks/useShareSocial/index_new';

type ShareSocialProps = {
	className?: string;
};

export function ShareSocial({ className }: ShareSocialProps): JSX.Element {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const actions = useShareSocial();

	const channels = actions.map((action) => action.channel);

	useTrackShareActionsView({ channels, petitionId: petition.id });

	return (
		<div className={className}>
			{actions.map(({ action, channel }) => {
				const { label, successLabel } = SHARE_BUTTON_CONFIG[channel];
				return (
					<div data-testid={`share-social-${channel.toLowerCase()}`} key={channel} className="sm:w-1/4 md:w-auto">
						<SharePetitionButton
							data-qa={`share-social-${channel.toLowerCase()}`}
							channel={channel}
							action={action}
							label={label}
							successLabel={successLabel}
						/>
					</div>
				);
			})}
		</div>
	);
}
